/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { CodeBlock } from '@neo4j-ndl/react';
import {
  PlayCircleIconOutline,
  Square2StackIconOutline,
} from '@neo4j-ndl/react/icons';

import { SHORT_CODE_EXAMPLE } from './example-code-snippets';

const Component = () => {
  return (
    <CodeBlock
      code={SHORT_CODE_EXAMPLE}
      language="typescript"
      maxHeight={320}
      actions={[
        {
          children: (
            <Square2StackIconOutline className="n-text-neutral-text-icon" />
          ),
          description: 'copy',
          htmlAttributes: { title: 'copy' },
          onClick: () => alert('Code copied to clipboard!'),
        },
        {
          children: <PlayCircleIconOutline className="n-text-primary-icon" />,
          description: 'run',
          htmlAttributes: { title: 'run' },
          onClick: () => alert('Running code...'),
        },
      ]}
    />
  );
};

export default Component;
